// videoデバイスの設定/接続/切断
const constraints = {
  audio: false,
  video: {
    width: { min: 640, max: 1920 },
    height: { min: 360, max: 1080 },
    facingMode: "environment"
  }
}
/**
 * カメラ起動処理（未使用のため、削除予定）
 */
export const startStreamedVideo = async (videoElem: any) => {
  await window.navigator.mediaDevices
    .getUserMedia(constraints)
    .then((stream) => {
      // 成功した時の処理
      videoElem.current.srcObject = stream
    })
    .catch((err) => {
      // エラー時
      console.error("getUserMedia Err:", err)
    })
  // カメラ接続を切断するためのリロード
  window.addEventListener("popstate", (e) => {
    window.location.reload()
  })
}
/**
 * カメラ停止処理
 * @param {any} videoElem - HTMLVideoElementを設定
 */
export const stopStreamedVideo = (videoElem: any) => {
  const stream = videoElem.srcObject
  if (stream != null) {
    const tracks = stream.getTracks()
    tracks.forEach((track: any) => {
      track.stop()
    })
    videoElem.srcObject = null
  }
}
